export default __webpack_public_path__ + "static/media/add-students.0894d313.svg";